import KendoDateTimePickerMixin from './KendoDateTimePickerMixin'

export default {
    name: 'kendo-datetimepicker',
    mixins: [ KendoDateTimePickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateTimePicker/index.js